import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '大屏展示1',
      component: () => import('@/views/screen1/index.vue'),
      meta: {
        title: '仓储一体化智能运维监测平台'
      }
    },
    {
      path: '/platform',
      name: '大屏展示',
      component: () => import('@/views/screen1/indexTwo.vue'),
      // meta: {
      //   title: '仓储一体化智能运维监测平台'
      // }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js